import {Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {faCircleQuestion, faInfoCircle} from "@fortawesome/pro-solid-svg-icons";
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, TooltipDirective,]
})
export class DashboardCardComponent implements OnInit, OnDestroy {
  @Input() tooltipText = ''
  @Output() headerClick = new EventEmitter<void>();

  /** True when the card height reaches the threshold (default 500px) */
  isFullHeight = false;

  protected readonly faInfoCircle = faInfoCircle;
  protected readonly faCircleQuestion = faCircleQuestion;

  private resizeObserver?: ResizeObserver;
  private readonly FULL_HEIGHT_THRESHOLD = 488; // ~500px minus padding

  constructor(private el: ElementRef, private zone: NgZone) {
  }

  ngOnInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      const height = entries[0]?.contentRect.height ?? 0;
      const full = height >= this.FULL_HEIGHT_THRESHOLD;
      if (full !== this.isFullHeight) {
        this.zone.run(() => this.isFullHeight = full);
      }
    });
    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  onHeaderClick(): void {
    this.headerClick.emit();
  }
}
